import React from 'react';

import { useSelector } from 'react-redux';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';

import AddBanner from './AddBanner';
import { useEventsCommunications } from './hooks';

function AddBannerContainer() {
  const isEnabled = featureFlags.getFlag('SBL_3233_DYNAMIC_BANNER');
  const organizationGuid = useSelector(organizationGuidSel);
  const { isEditAllowed } = useEventsCommunications();

  if (!isEnabled || !isEditAllowed(organizationGuid)) {
    return null;
  }

  return <AddBanner />;
}

export default AddBannerContainer;
